import TransactionEditForm from "../Components/TransactionEditForm";

export default function Edit() {
  return (
    <div>
      <TransactionEditForm />
    </div>
  );
}
